import React from 'react';

const About = () => {
    return (
        <div className='md:w-3/4 shadow-xl mb-20 px-10 pb-10 mx-auto rounded-xl'>
            <h1 className='text-4xl font-bold mb-10'>About me
            </h1>
            <p className='text-start text-lg'>A passionate and intermediate front-end web developer who is currently a student of Mathematics. When I first became interested in coding, I researched and self-taught myself about web development. The more I learned, the more intrigued I became. <br />

                To learn more about web development, I enrolled in and completed a course from programming hero. They taught me about JavaScript, React JS, Node JS, Express JS, MongoDB, Tailwind, Bootstrap, Stripe, and JWT. I completed a total of 12 assignments, including three full-stack projects. While working on these projects, I encountered various errors, which taught me how to effectively fix bugs. <br />

                I am a fast learner and an adaptable person who can easily adapt to any situation. Possess the potential to be a leader and work well as part of a team. Capable of performing multiple tasks at once and organized in the management of both people and work. <br />

                Regards, <br />
                Nusrat Jahan <br />
                nusratjahanmithila66@gmail.com <br />
                +8801533700315 (WhatsApp)
            </p>
        </div>
    );
};

export default About;